// eslint-disable-next-line no-restricted-exports
export { default } from './DropdownMenuItem';
export * from './DropdownMenuItem';
